import _Tree from "./src/tree.vue";
import { withInstall } from "@chenms-zj/utils/with-install";

const Tree = withInstall(_Tree);

// 可以通过app.use来使用 也可以通过import的方式单独使用
export default Tree;

export * from "./src/tree";

// 这里添加的类型，可以在模板中被解析
declare module "vue" {
  // 我们的接口可以自动合并
  export interface GlobalComponents {
    "cms-tree": typeof Tree;
  }
}
